export const gatewayEndpoints: [string, string][] = [];

export function registerGateway(name: string, endpoint: any): void {
  gatewayEndpoints.push([name, endpoint]);
}
